import { render, staticRenderFns } from "./TestTaskDetailCardstack.vue?vue&type=template&id=2d4bebb4"
import script from "./TestTaskDetailCardstack.vue?vue&type=script&lang=js"
export * from "./TestTaskDetailCardstack.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports